export default function ($scope, $location) {

    console.log($location.absUrl());
};


/** WEBPACK FOOTER **
 ** ./js/theme/download/controller.js
 **/